import { render, staticRenderFns } from "./SectionLocationV1.vue?vue&type=template&id=54d8b23c&"
import script from "./SectionLocationV1.vue?vue&type=script&lang=js&"
export * from "./SectionLocationV1.vue?vue&type=script&lang=js&"
import style0 from "./SectionLocationV1.vue?vue&type=style&index=0&id=54d8b23c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports